/**
 *
 *    DD TO / UPDATE / DELETE FROM CART
 *    Contains all functions needed to add, update or delete a product from the cart
 *
 */

// Add item to shopping cart with check on stock
function AddToCart(objButton, blnShowAddToCartQtyField, blnRemoveDecimals) {
    $(objButton).click(function () {
        var objButton = $(this);
        var objForm = $(this).parents('form:first');
        // When there has to be checked on stock
        if (WebsiteSettingBlnCheckStockAddCart && WebsiteSettingBlnUseStock) {
            // Check whether there's enough stock of this product
            // Hide previous error (if needed)
            $(objForm).parents().find('.text-danger').remove();

            let intQuantity = 1;

            if ($(objForm).find('input[name=\'txtQuantity\']').length) {
                intQuantity = $(objForm).find('input[name=\'txtQuantity\']').val();
            } else {
                intQuantity = $(objForm).find('input[name=\'hdnQuantity\']').val();
            }

            // Check stock from product
            $.post(strAjaxPath + 'cart/check-stock.php', 'intArticleNo=' + $(objForm).find('input[name=\'hdnArticleNo\']').val() + '&intPriceNo=' + $(objForm).find('input[name=\'hdnPriceNo\']').val() + '&intQuantity=' + intQuantity, function (data) {
                if (!objButton.hasClass('just-added')) {
                    // Add check so the user doesn't click quickly twice on the button
                    objButton.addClass('just-added');
                    setTimeout(function () {
                        objButton.removeClass('just-added');
                    }, 2000);

                    if (data.value == 0) {
                        // Not enough stock => show error
                        var objDivStockError = $('<div class=\'alert-danger show mb-3 p-2\'></div>');
                        objDivStockError.html(data.message);
                        $(objForm).before(objDivStockError);
                    } else {
                        // Enough stock => add product(s) to cart
                        AddProductToCart(objForm, objButton, blnShowAddToCartQtyField, true);
                    }
                }
            });
        } else {
            // No check on stock => add product to cart
            AddProductToCart(objForm, objButton, blnShowAddToCartQtyField, true);
        }

        return false;
    });
}

// Add item to shopping cart
function AddProductToCart(objForm, objButton, blnShowAddToCartQtyField, blnRemoveDecimals, strParams) {
    // Initialise if the quantity has to be rounded on 0 decimals (after the comma)
    if (typeof blnRemoveDecimals == 'undefined' || blnRemoveDecimals == '') {
        blnRemoveDecimals = true;
    }

    if (typeof strParams == 'undefined') {
        strParams = '';
    }

    // remove all previous errors
    $(objForm).find('.alert.alert-danger').remove();

    // There is no quantity field or it doesn't have to be checked
    var blnAddZero = false;
    // Check on quantity = 0 (if needed)
    if (blnShowAddToCartQtyField) {
        // Hide previous error (if needed)
        $(objForm).find('div.quantity-error').remove();
        var blnAddZero = true;
        $(objForm).find('input[name=\'txtQuantity\']').each(function () {
            if ($(this).val() > 0) {
                blnAddZero = false;
            }
        });
        if (blnAddZero) {
            // Show error when they try to add 0 items
            var objDivQuantityError = $('<div class=\'alert error quantity-error\'>' + lblOrderAtLeastOne + '</div>');
            $(objForm).append(objDivQuantityError);
        }
    } else {
        // There is no quantity field or it doesn't have to be checked
        var blnAddZero = false;
    }

    if (!blnAddZero) {
        // Ensure that there are no decimal numbers added (if necessary)
        if (blnShowAddToCartQtyField && blnRemoveDecimals) {
            $(objButton).parent().find('input[name=\'txtQuantity\']').each(function () {
                $(this).val(Math.ceil($(this).val()));
            });
        }

        let intQuantity = 1;
        // Check if no params were given with the function
        if (strParams == '') {
            // Make strParams
            if ($(objForm).find('input[name=\'txtQuantity\']').length) {
                intQuantity = $(objForm).find('input[name=\'txtQuantity\']').val();
            } else {
                intQuantity = $(objForm).find('input[name=\'hdnQuantity\']').val();
            }
            strParams = 'intArticleNo=' + $(objForm).find('input[name=\'hdnArticleNo\']').val() + '&intPriceNo=' + $(objForm).find('input[name=\'hdnPriceNo\']').val() + '&intQuantity=' + intQuantity;
        }

        // Check if a product was added to the cart from the cart page
        let refreshCartTable = typeof(strPage) !== 'undefined' && strPage === 'cart';
        if(refreshCartTable){
            strParams += '&blnUpdateCartTable=true'
            // Check if the related products are shown in a carousel/slider
            let blnIsCarousel = $('.cart-related-products .product-overview').hasClass('slick-slider');

            // To make sure the related products appear in the same order when one of them is added (and thus removed from the list),
            // create an array with the current order of the articles
            let articleNos = [];
            if(blnIsCarousel){
                let sliderArticleNos = [];
                $('div.slick-slide:not(.slick-cloned) div.product-overview-item input[name="hdnArticleNo"]').each(function(){
                    if(!sliderArticleNos.includes($(this).val())){
                        sliderArticleNos.push($(this).val());
                    }
                });
                let currentSlideArticleNo = $('div.slick-slide.slick-current:not(.slick-cloned) div.product-overview-item input[name="hdnArticleNo"]').val();
                let startIndex = sliderArticleNos.indexOf(currentSlideArticleNo);
                // Rotate the array of articleNos, so it starts with the currently first visible item
                articleNos = sliderArticleNos.slice(startIndex).concat(sliderArticleNos.slice(0, startIndex));
            } else {
                $('div.product-overview-item input[name="hdnArticleNo"]').each(function(){
                    if(!articleNos.includes($(this).val())) {
                        articleNos.push($(this).val());
                    }
                });
            }
            // Remove the just added article from the list of articleNos
            let addedArticleNo = $(objForm).find('input[name="hdnArticleNo"]').val();
            let removeIndex=  articleNos.indexOf(addedArticleNo);
            if(removeIndex !== -1){
                articleNos.splice(removeIndex, 1);
            }
            // Pass the order of the articles to the ajax call
            strParams += "&strSortOrder=" + articleNos.join(",");
        }

        let refreshProductAddedPopup = typeof(strPage) !== 'undefined' && strPage === 'product-added';
        if(refreshProductAddedPopup) {
            strParams += '&blnUpdateCartPopup=true'
        }

        // Add items to cart
        $.post(strAjaxPath + 'cart/cart.php', strParams, function (data) {
            if (data?.errors) {
                data.errors.forEach(function (error) {
                    const objDivStockError = $('<div class=\'alert alert-danger mb-2\'></div>');
                    objDivStockError.html(error);
                    $(objForm).append(objDivStockError);
                });
                return;
            }
            // Product was added to cart
            // Show popup if the current page is not the cart page or the popup
            if(refreshCartTable){
                // Refresh the cart table, related products, prices, discount and make sure the event listeners are added again
                $('.cart-related-products').html(data['cartrelatedproducts']);
                InitAddToCart();
                initializeRelatedProducts(5);
                updateCartPage(data);
                incrementValue();
                initializeCartTable();
            } else if(refreshProductAddedPopup){
                // Articles were added to the cart via the popup (by clicking on the staffels options), so update the popup
                AddToCart($('form#frmAddToCart button#btnAddToCart'), true, true);
                $('div.cart-staffels').remove();
                $('div.popup-mini-cart').html(data['miniCartDropdown']);
                $('a#btnCart').attr('target', '_parent');
                let parentBody = window.parent.document.body;
                let newHeight = $('div.popup.product-added').innerHeight();
                $("div.fancybox-content", parentBody).css('height', newHeight + 30)
            } else {
                var strHrefPopupProductAdded = $(objForm).find('input[name=\'hdnHrefPopupProductAdded\']').val();
                strHrefPopupProductAdded += "?quantity=" + intQuantity;
                var objA = $('<a data-fancybox=\'iframe\' data-src=\'' + strHrefPopupProductAdded + '\'  data-type=\'iframe\' href=\'javascript:;\'></a>');
                objForm.append(objA);
                // Open 'Product added' popup
                objA.fancybox({
                    autoSize: true,
                    iframe: {
                        preload: true,

                        css: {
                            width: '1000px',
                        },
                    },
                    afterClose: function () {
                        objA.remove();
                    },
                });

                objA.click();
            }

            // Enhanced E-commerce
            gtagCartEvent(data.product, "add_to_cart");

            // Update mini cart in pagehead
            UpdateMiniCart();

            if (objButton.attr("data-product-detail")) {
                var objCheck = objButton.find(".fa-check");
                if (objCheck?.length > 0) {
                    var objIcon = objButton.find('.fa-stack-1x');
                    var objIconCheck = objButton.attr('data-check');
                    var objIconCart = objButton.attr('data-cart');
                    var objIconLoader = objButton.attr('data-loader');

                    setTimeout(function () {
                        objIcon.removeClass(objIconCart);
                        objIcon.addClass(objIconLoader);
                    }, 1000);

                    setTimeout(function () {
                        objIcon.removeClass(objIconLoader);
                        objIcon.addClass(objIconCheck);
                    }, 2500);

                    setTimeout(function () {
                        objIcon.removeClass(objIconCheck);
                        objIcon.addClass(objIconCart);
                    }, 3500);

                    if (objCheck.hasClass("d-none")) {
                        objCheck.removeClass("d-none");
                    }
                }
            } else {
                updateCartBtnStyling(objButton);
            }

        }, 'json');
    }
}

function updateCartBtnStyling(objButton) {
    //-- Update styling add-to-cart-button
    let formAddToCart = $(objButton).closest('form');
    if (formAddToCart?.length > 0) {
        let btnAdded = formAddToCart.find(".btn-added");
        if (!objButton.hasClass("d-none")) {
            objButton.addClass("d-none");
        }
        if (btnAdded.hasClass("d-none")) {
            btnAdded.removeClass("d-none");
        }
    }
}

// Update mini cart in pagehead
function UpdateMiniCart() {
    $.post(strAjaxPath + 'cart/mini-cart.php', '', function (data) {
        //$("div#mini-cart-container").html(data);
        $('div#mini-cart-container').replaceWith(data);
    }, 'html');
}

// Update quantity in cart
function CartUpdateCart(objInput, blnCheckStock) {
    if (typeof blnCheckStock === 'undefined') {
        blnCheckStock = false;
    }

    // Ensure that there are no decimal numbers added (if necessary)
    objInput.val(Math.ceil(objInput.val()));
    var objForm = objInput.parents('form:first');

    // Get articleno and priceno from id from input field
    var strQtyId = objInput.attr('id');
    var arrQtyId = strQtyId.split('_');
    var intArticleNo = arrQtyId[1];
    var intPriceNo = arrQtyId[2];
    var intQuantity = objInput.val();

    // Check stock (if needed)
    if (blnCheckStock) {
        // Hide previous error (if needed)
        $('form#frmCartTable').find('div.alert-danger').remove();

        var strSelQtyId = strQtyId.replace('qty', 'selQty');

        if (intArticleNo > 0 && intPriceNo > 0) {
            // Check stock via ajax
            $.post(strAjaxPath + 'cart/check-stock.php', 'intArticleNo=' + intArticleNo + '&intPriceNo=' + intPriceNo + '&intQuantity=' + intQuantity + '&strType=cart', function (data) {
                // data = eval('(' + data + ')');
                if (data.value == 1) {
                    // Update cart
                    UpdateCart(intArticleNo, intPriceNo, intQuantity);

                } else {
                    // Show error
                    var objDivStockError2 = $('<div class=\'alert alert-danger mb-2\'></div>');
                    objDivStockError2.html(data.messagecart);
                    $('form#frmCartTable').prepend(objDivStockError2);

                    // Change quantity to quantity on stock
                    $('#' + strQtyId).val(data.stock);
                    $('#' + strSelQtyId).val(data.stock);
                    if (data.stock == 0) {
                        $('#' + strQtyId).closest('tr').addClass('d-none');
                    }

                    // Update cart
                    UpdateCart(intArticleNo, intPriceNo, data.stock);
                }

                return false;
            });
        }
    } else {
        UpdateCart(intArticleNo, intPriceNo, intQuantity);
    }
}

// Update cart (in cart-table) (the updating itself, no checks)
function UpdateCart(intArticleNo, intPriceNo, intQuantity) {
    if (intArticleNo > 0 && intPriceNo > 0 && intQuantity >= 0) {
        $.post(strAjaxPath + 'cart/cart.php', 'intArticleNo=' + intArticleNo + '&intPriceNo=' + intPriceNo + '&intQuantity=' + intQuantity + '&strAction=update', function (arrData) {
            gtagCartEvent(arrData.product, arrData.updateEvent);
            updateCartPage(arrData);
        }, 'json');
    }
}

// Remove item from cart
function RemoveFromCart(intCartKey) {
    strParams = 'intCartKey=' + intCartKey + '&strAction=delete';
    $.post(strAjaxPath + 'cart/cart.php', strParams, function (data) {
        // Reload page
        gtagCartEvent(data.product, "remove_from_cart");
        document.location.reload();
    }, 'json');
}

function updateCartPage(arrData){
    if(arrData['carttable'] !== ""){
        $('.cart-table').html(arrData['carttable']);
    }

    if (WebsiteSettingBlnShowVatSeparatelyInCart) {
        // VAT is a seperate rule in cart-total table
        // Update subtotal
        $('span#cart-subtotal-price').html(arrData['cartprice']['subtotalexclvat']);

        // Update vat total
        $('span#cart-vat-price').html(arrData['cartprice']['vat']);

        // Update transport
        $('span#cart-transport-price').html(arrData['cartprice']['transportexcl']);
    } else {
        // All totals/subtotals are shown incl. VAT in cart
        // Update subtotal
        $('span#cart-subtotal-price').html(arrData['cartprice']['subtotalinclvat']);

        // Update transport
        $('span#cart-transport-price').html(arrData['cartprice']['transport']);
    }

    // Remove all discount lines
    $('div#cart-discount').remove();
    // Check if there are discounts
    if (arrData.discount.length > 0) {
        // Add discount lines
        $('div#cart-subtotal').after(arrData.discount);
    }

    // Update total
    $('span#cart-total-price').html(arrData['cartprice']['total']);

    // Remove all giftcard lines
    $('div#cart-giftcard').remove();
    if (arrData['cartprice']['giftcards'] != '') {
        // Add giftcard lines
        $.each(arrData['cartprice']['giftcards'], function (intKey, arrGiftcardLine) {
            var objTrGiftcard = $('<tr id=\'cart-giftcard\'></tr>');
            var objTdGiftcardLabel = $('<td class=\'first\'></td>');
            objTdGiftcardLabel.html(arrGiftcardLine['label']);
            var objTdGiftcardPrice = $('<td></td>');
            objTdGiftcardPrice.html(arrGiftcardLine['price']);
            objTrGiftcard.append(objTdGiftcardLabel);
            objTrGiftcard.append(objTdGiftcardPrice);
            $('div#total-before-giftcards').after(objTrGiftcard);
        });

        // Update total after discount
        $('div#cart-total span#cart-price-total').html(arrData['cartprice']['total_after_discount']);
    }

    // Update price/subtotal per product line
    $.each(arrData['cart'], function (intKey, arrCartLine) {
        // Update unit price per product line
        var objTrProduct = $('tr[data-key="' + arrCartLine.articleno + '_' + arrCartLine.priceno + '"]');
        objTrProduct.find('span[data-name="unit-price"]').html(arrCartLine['price'][arrCartLine['priceno']]['priceformat']);
        // Show/add info-icon for staffel
        if (arrCartLine.staffel) {
            objTrProduct.find('button[data-name="staffel-tooltip"]').removeClass('d-none').addClass('d-flex');
        } else {
            objTrProduct.find('button[data-name="staffel-tooltip"]').addClass('d-none').removeClass('d-flex');
        }

        // Update subtotals per product line
        if (WebsiteSettingBlnShowVatSeparatelyInCart) {
            // VAT is a seperate rule in cart-total table
            // Update subtotal for product line
            $('span#subtotal_' + arrCartLine['articleno'] + '_' + arrCartLine['priceno']).html(arrCartLine['price'][arrCartLine['priceno']]['subtotalexcl']);
        } else {
            // All totals/subtotals are shown incl. VAT in cart
            // Update subtotal for product line
            $('span#subtotal_' + arrCartLine['articleno'] + '_' + arrCartLine['priceno']).html(arrCartLine['price'][arrCartLine['priceno']]['subtotal']);
        }
    });

    // Check if message until free transport
    if (arrData.strMessageTransport != '') {
        $('#message-transport').text(arrData.strMessageTransport);
        $('#message-transport').removeClass('d-none');
    } else {
        $('#message-transport').text('');
        $('#message-transport').addClass('d-none');
    }
}

function gtagCartEvent(data, event){
    gtag("event", event, {
        currency: "EUR",
        value: data.price,
        items: [
            {
                item_id: data.articlecode + ' - ' + data.articlename,
                item_name: data.articlename,
                index: data.index,
                item_brand: data.make.makename,
                item_category: data.categories,
            }
        ]
    });
}

window.AddToCart = AddToCart;
window.UpdateMiniCart = UpdateMiniCart;
window.RemoveFromCart = RemoveFromCart;
window.UpdateCart = UpdateCart;
window.CartUpdateCart = CartUpdateCart;
window.AddProductToCart = AddProductToCart;